import { render, staticRenderFns } from "./ProductServiceUpgrade.vue?vue&type=template&id=a2e9b56e"
import script from "./ProductServiceUpgrade.vue?vue&type=script&lang=js"
export * from "./ProductServiceUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports